import { Tag } from '@sm-dashboard/reshet-types';
import { routes } from '@/app/app';

export const ADMIN_SYSTEM_TAG = 'מנהל מערכת';
export const MANAGER_TAG = 'מנהל';

export class UserPermission {
  private allowedPages: Set<string>;
  public userTags: Set<string>;
  public isAdmin = false;
  public isAdminInstitutions = false;
  public operations: number[] = [];

  private formatPage(page: string): string {
    // Remove all dynamic parameters (e.g., '/:id', '/:formId', etc.) from anywhere in the path
    const cleaned = page.replace(/\/:[^/]+/g, '');
    // Remove trailing slashes except for root
    const normalized = cleaned === '/' ? cleaned : cleaned.replace(/\/+$/, '');
    return normalized.startsWith('/') ? normalized : `/${normalized}`;
  }

  constructor(tags: Tag[], userTags: string[]) {
    this.allowedPages = new Set<string>();
    this.userTags = new Set(userTags);
    this.isAdmin = userTags.some(tag => tag === ADMIN_SYSTEM_TAG);
    tags.forEach(tagObj => {
      if (this.userTags.has(tagObj.tag)) {
        try {
          const pages = JSON.parse(tagObj?.hasPermissionPages || '');

          if (pages.includes('גישה חופשית') || pages.includes('free-access')) {
            this.allowedPages = new Set(routes.map(route => this.formatPage(route.route)));
            this.allowedPages.add('free-access');
            return;
          }

          pages.forEach((page: string) => {
            this.allowedPages.add(this.formatPage(page));
          });
        } catch (e) {
          console.error(`Failed to parse hasPermissionPages for tag ${tagObj.tag}`);
        }
        if (tagObj.operations) {
          this.operations = [...this.operations, ...tagObj.operations];
        }
      }
    });
  }

  hasPagePermission(page: string): boolean {
    // Allow if page is empty or just slash
    if (!page || page === '/') {
      return true;
    }
    // Remove query parameters for permission check
    const [pathWithoutQuery] = page.split('?');
    // Remove trailing slashes except for root
    const normalizedPath = pathWithoutQuery === '/' ? pathWithoutQuery : pathWithoutQuery.replace(/\/+$/, '');
    // Remove all ID-like segments (number or hex string) from anywhere in the path
    const basePath = normalizedPath
      .split('/')
      .filter(segment => !/^([a-fA-F0-9]{8,}|[0-9]+)$/.test(segment))
      .join('/');
    // Ensure leading slash
    const formattedBasePath = basePath.startsWith('/') ? basePath : `/${basePath}`;
    return this.allowedPages.has(formattedBasePath) || this.allowedPages.has('free-access');
  }

  hasTag(tagName: string): boolean {
    return this.userTags.has(tagName);
  }

  getAllowedPages(): string[] {
    return Array.from(this.allowedPages);
  }

  hasOnlyOneTag(tagName: string): boolean {
    return this.userTags.size === 1 && this.userTags.has(tagName);
  }

  isAdminTag(tagName: string): boolean {
    return tagName === ADMIN_SYSTEM_TAG;
  }
}
